import {
  LayoutOptions,
  PrimaryBlockType,
  processLayoutOptions,
  MediaProp,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";
import { BackgroundColors } from "@kameleon-util/global-theme";

export const layoutOptions = {
  backgroundColor: LayoutOptions.List([
    // currently only dark
    BackgroundColors.dark,
  ]),
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type Item = {
  header: string;
  image?: MediaProp;
};

export type EyecatcherType = {
  /** Place prop documentation here */
  tagline: string;
  items: Item[];
} & PrimaryBlockType<LayoutProps>;
